import type { ICustomFieldType } from 'entities/CustomField'

export const getCustomTypeByData = (type: string): ICustomFieldType => {
  switch (type) {
    case 'text':
    case 'url':
    case 'date':
    case 'datetime':
    case 'number':
      return type
    default:
      return 'text'
  }
}
